import { createContext, FC, ReactNode, useContext, useState } from "react"

type CertificateRequestsBatchModalContextType = {
  batchModalOpen: boolean
  certificateId: string | null
  openBatchModal: ({
    certificateId,
    certificateRequestId,
  }: {
    certificateId: string
    certificateRequestId: string
  }) => void
  closeBatchModal: () => void
  certificateRequestId?: string
}

const CertificateRequestsBatchModalContext =
  createContext<CertificateRequestsBatchModalContextType>({
    batchModalOpen: false,
    certificateId: null,
    openBatchModal: ({
      certificateId,
      certificateRequestId,
    }: {
      certificateId: string
      certificateRequestId: string
    }) => {
      void certificateId
      void certificateRequestId
    },
    closeBatchModal: () => {
      void 0
    },
  })

export const useCertificateRequestsBatchModalContext = () => {
  const context = useContext(CertificateRequestsBatchModalContext)
  if (!context) {
    throw new Error(
      "useCertificateRequestsBatchModalContext must be used within a CertificateRequestsBatchModalProvider"
    )
  }
  return context
}

export const CertificateRequestsBatchModalProvider: FC<{
  children: ReactNode
}> = ({ children }) => {
  const [batchModalOpen, setBatchModalOpen] = useState(false)
  const [certificateId, setCertificateId] = useState<string | null>(null)
  const [certificateRequestId, setCertificateRequestId] = useState<
    string | undefined
  >()

  const openBatchModal = ({
    certificateId,
    certificateRequestId,
  }: {
    certificateId: string
    certificateRequestId: string
  }) => {
    setCertificateId(certificateId)
    setCertificateRequestId(certificateRequestId)
    setBatchModalOpen(true)
  }

  const closeBatchModal = () => {
    setCertificateId(null)
    setCertificateRequestId(undefined)
    setBatchModalOpen(false)
  }

  return (
    <CertificateRequestsBatchModalContext.Provider
      value={{
        batchModalOpen,
        certificateId,
        certificateRequestId,
        openBatchModal,
        closeBatchModal,
      }}
    >
      {children}
    </CertificateRequestsBatchModalContext.Provider>
  )
}
